import React, { Fragment } from 'react'
import { Route } from 'react-router-dom';
import { RolePermissionListing } from './Pages'

export const RolePermissionRoutes = ({ match }) => (
    <Fragment>
        <Route exact path={`${match.path}`} component={RolePermissionListing} />
    </Fragment>
)